export default "__VITE_ASSET__Dkfu9rfF__"